/**
 * Frame ajax calls
 */
export const frame = () => {
	document.addEventListener('DOMContentLoaded', function () {
		const pathName = window.location.pathname;
		const frameValue = '/frame/';
		const savingValue = 'savings-products';
		const isPage = document.body.classList.contains('page');
		const isSavings = pathName.indexOf('savings-products');

		if (
			(pathName.indexOf('/frame/') > -1 && isPage) ||
			(pathName.indexOf('/frame/') > -1 && isSavings)
		) {
			let code = '';
			const pathArray = pathName.split('/');
			if (pathArray[1] === savingValue) {
				code = pathArray[2];
			}
			const page = pathName.replace(frameValue, '');
			const data = new URLSearchParams({
				action: 'load_post_content',
				nonce: Ajax.Nonce, // eslint-disable-line
				path: page.slice(1),
				code,
			});

			fetch(Ajax.ajax_url, { // eslint-disable-line
				method: 'POST',
				body: data,
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
			})
				.then((response) => response.text())
				.then((response) => {
					const responseObj = JSON.parse(response);

					if (responseObj.success) {
						document.getElementById('content').innerHTML =
							responseObj.content;
					}

					document.getElementById('content').classList.add('loaded');

					const breadcrumbs = document.querySelector(
						'.yoast-breadcrumbs span'
					);
					if (breadcrumbs) {
						breadcrumbs.remove();
					}

					if (responseObj.theme) {
						// Remove script
						const oldScript = document.getElementById(
							responseObj.theme + '-theme_theme-js-js'
						);
						if (oldScript) {
							oldScript.remove();
						}
						// Reload script
						const mainScript = document.createElement('script');
						mainScript.src =
							document.location.origin +
							'/wp-content/themes/' +
							responseObj.theme +
							'/dist/js/scripts.js';
						document.head.appendChild(mainScript);
					}

					if (code) {
						document.title = code;
					} else if (responseObj.title) {
						document.title = responseObj.title;
					}
				})
				.catch((error) => {
					console.error('Error:', error); // eslint-disable-line
				});
		} else {
			document.getElementById('content').classList.add('loaded');
		}
	});
};
